window.onload = function() {
  var formSelect = document.querySelector('.select-form-type');
  var form1 = document.querySelector('#form1');
  var form2 = document.querySelector('#form2');
  var form3 = document.querySelector('#form3');
  
  function toggleForm() {
    var formSelected = formSelect.value;
    
    form1.classList.add('form-hidden');
    form2.classList.add('form-hidden');
    form3.classList.add('form-hidden');
    
    if (formSelected == 'form1') {
      form1.classList.toggle('form-hidden');
    }
    if (formSelected == 'form2') {
      form2.classList.toggle('form-hidden');
    }
    if (formSelected == 'form3') {
      form3.classList.toggle('form-hidden');
    }
  }

  if (formSelect){
  formSelect.addEventListener('change', toggleForm);
  }
  
}();